import store from "@/store/index";
import router from "@/router/index";

export function GetBaseMetaData() {
  const metaDataList = store.state.pageMetaData;
  let baseMetaData = metaDataList.filter(
    (item) => item.PageTitle == "所有頁面"
  )[0];
  baseMetaData.Content = baseMetaData.Content.replaceAll(/<[^>]+>/g, "");
  if (baseMetaData.Content.length > 155) {
    baseMetaData.Content = baseMetaData.Content.slice(0, 155) + "...";
  }

  return {
    title: baseMetaData.Title,
    content: baseMetaData.Content,
    image: GetImageUrl(baseMetaData.Image),
  };
}

export function GetMetaData(title, content = "", image = "") {
  const defaultMeta = GetBaseMetaData();
  title == "" ? (title = "官方網站") : "";

  return {
    title: title + defaultMeta.title,
    meta: [
      {
        property: "og:url",
        name: "og:url",
        content: process.env.VUE_APP_BASEURL + router.history.current.fullPath,
        vmid: "og:url",
      },
      {
        property: "og:title",
        name: "og:title",
        content: title + defaultMeta.title,
        vmid: "og:title",
      },
      {
        property: "og:description",
        name: "og:description",
        content: content == "" ? defaultMeta.content : content,
        vmid: "og:description",
      },
      {
        property: "twitter:description",
        name: "twitter:description",
        content: content == "" ? defaultMeta.content : content,
        vmid: "twitter:description",
      },
      {
        property: "description",
        name: "description",
        content: content == "" ? defaultMeta.content : content,
        vmid: "description",
      },
      {
        property: "og:image",
        name: "og:image",
        content: image == "" ? defaultMeta.image : image,
        vmid: "og:image",
      },
      {
        property: "apple-mobile-web-app-title",
        name: "apple-mobile-web-app-title",
        content: title + defaultMeta.title,
        vmid: "apple-mobile-web-app-title",
      },
      {
        property: "application-name",
        name: "application-name",
        content: title + defaultMeta.title,
        vmid: "application-name",
      },
      {
        property: "og:site_name",
        name: "og:site_name",
        content: "官方網站" + defaultMeta.title,
        vmid: "og:site_name",
      },
      {
        property: "og:type",
        name: "og:type",
        content: "website",
        vmid: "og:type",
      },
      {
        property: "og:locale",
        name: "og:locale",
        content: "zh_tw",
        vmid: "og:locale",
      },
    ],
  };
}

function GetImageUrl(item) {
  return item == "" ? "" : process.env.VUE_APP_BASE_API + item;
}
